import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useMemo, useState } from 'react';
import { DetailsPageCard } from './DetailsPageCard';
import { PricingPlan } from '../../pricing/PricingPlan';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { View } from 'foundations-components/transitional/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { useDetailsPageContext } from '../../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function ProductPricingCard({
  agencyPricingUrl,
  currency,
  pricingUrl,
  pricings
}) {
  var _pricings$;
  const {
    appContext,
    name
  } = useDetailsPageContext();
  const isCustomer = appContext === 'app';
  const [selectedPricingIndex, setSelectedPricingIndex] = useState(0);
  const renderedPricingCardBody = useMemo(() => {
    if (pricings.length > 1) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.pricingCard.subTitle",
            options: {
              name
            }
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            marginInlineEnd: "400",
            inlineSize: "50%",
            children: pricings.map((pricing, index) => /*#__PURE__*/_jsx(SelectableBox, {
              selected: selectedPricingIndex === index,
              onClick: () => setSelectedPricingIndex(index),
              type: "default",
              marginBlockEnd: "200",
              children: /*#__PURE__*/_jsxs(Flex, {
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "start",
                children: [/*#__PURE__*/_jsxs(Flex, {
                  justifyContent: "space-between",
                  alignItems: "center",
                  inlineSize: "100%",
                  children: [/*#__PURE__*/_jsx(Text, {
                    as: "strong",
                    children: pricing.name
                  }), pricing.freeTrialDays ? /*#__PURE__*/_jsx(Badge, {
                    use: "koala",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: `detailsPage.pricingCard.plan.freeTrialBadgeText`,
                      options: {
                        freeTrialDays: pricing.freeTrialDays
                      }
                    })
                  }) : null]
                }), /*#__PURE__*/_jsx(Text, {
                  as: "small",
                  textAlign: "left",
                  children: pricing.tagline
                })]
              })
            }, `pricing-box-${index}`))
          }), /*#__PURE__*/_jsx(PricingPlan, {
            currency: currency,
            pricing: pricings[selectedPricingIndex]
          })]
        })]
      });
    } else {
      return /*#__PURE__*/_jsx(Flex, {
        flexGrow: 1,
        justifyContent: "start",
        children: /*#__PURE__*/_jsx(PricingPlan, {
          currency: currency,
          pricing: pricings[selectedPricingIndex]
        })
      });
    }
  }, [currency, name, pricings, selectedPricingIndex]);
  return /*#__PURE__*/_jsxs(DetailsPageCard, {
    id: "details-page-pricing",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.pricingCard.title"
    }),
    actions: /*#__PURE__*/_jsxs("div", {
      children: [agencyPricingUrl && /*#__PURE__*/_jsx(Button, {
        use: "link",
        external: true,
        href: agencyPricingUrl,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.pricingCard.agencyPricingLinkText"
        })
      }), pricingUrl && /*#__PURE__*/_jsx(Button, {
        use: "link",
        external: true,
        href: pricingUrl,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.pricingCard.pricingLinkText"
        })
      })]
    }),
    children: [renderedPricingCardBody, /*#__PURE__*/_jsx(View, {
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.pricingCard.disclaimerText_jsx",
          elements: {
            b: 'b',
            Date: FormattedDateTime
          },
          options: {
            format: 'L',
            type: isCustomer ? 'portalTz' : 'utc',
            value: (_pricings$ = pricings[0]) === null || _pricings$ === void 0 ? void 0 : _pricings$.updatedAt
          }
        })
      })
    })]
  });
}